import { render, staticRenderFns } from "./ChatFlutuante.vue?vue&type=template&id=68309535&scoped=true"
import script from "./ChatFlutuante.vue?vue&type=script&lang=js"
export * from "./ChatFlutuante.vue?vue&type=script&lang=js"
import style0 from "./ChatFlutuante.vue?vue&type=style&index=0&id=68309535&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68309535",
  null
  
)

export default component.exports